import Vue from "vue";
import Router from "vue-router";

/* 
 *  vueファイルインポート
 */
import HomePage from "./views/HomePage.vue";
import HomePageMainte from "./views/HomePageMainte.vue";
import ServicePolicy from "./views/ServicePolicy.vue";
import Help from "./views/Help.vue";
import Inquiry from "./views/Inquiry.vue";
import Login from "./views/Login.vue";
import ResetPwdRequest from "./views/ResetPwdRequest.vue";
import AuthConfirm from "./views/AuthConfirm.vue";
import AccountRegist from "./views/AccountRegist.vue";
import AccountModify from "./views/AccountModify.vue";
import AccountSuspend from "./views/AccountSuspend.vue";
import PwdChange from "./views/PwdChange.vue";
import PwdReset from "./views/PwdReset.vue";
import MemberHome from "./views/MemberHome.vue";
import InputRequestHome from "./views/InputRequestHome.vue";
import InputRequestConfirm from "./views/InputRequestConfirm.vue";
import InputRequestConfirmRegist from "./views/InputRequestConfirmRegist.vue";
import InputRequestAfterDescription from "./views/InputRequestAfterDescription.vue";

import MainteLogin from "./views/MainteLogin.vue";
import MainteManagerHome from "./views/MainteManagerHome.vue";
import MainteAccountRegist from "./views/MainteAccountRegist.vue";
import MainteAccountModify from "./views/MainteAccountModify.vue";
import MainteAccountListSearch from "./views/MainteAccountListSearch.vue";
import MainteInquiryListSearch from "./views/MainteInquiryListSearch.vue";
import MainteInquiryConfirm from "./views/MainteInquiryConfirm.vue";
import MainteRequestListSearch from "./views/MainteRequestListSearch.vue";
import MainteRequestConfirm from "./views/MainteRequestConfirm.vue";


import VFHomePage from "./views/VFHomePage.vue";
import VFHomePageMainte from "./views/VFHomePageMainte.vue";
import VFVerifyGuidance from "./views/VFVerifyGuidance.vue";
import VFVerifyDocSelect from "./views/VFVerifyDocSelect.vue";
import VFDocPhoto1 from "./views/VFDocPhoto1.vue";
import VFDocPhoto2 from "./views/VFDocPhoto2.vue";
import VFDocPhoto3 from "./views/VFDocPhoto3.vue";
import VFFacePhoto1 from "./views/VFFacePhoto1.vue";
import VFFacePhoto2 from "./views/VFFacePhoto2.vue";
import VFAppCompleted from "./views/VFAppCompleted.vue";

import VFLogin from "./views/VFLogin.vue";
import VFVerifyHome from "./views/VFVerifyHome.vue";
import VFReceiptAppListSearch from "./views/VFReceiptAppListSearch.vue";
import VFAppDetailsViewDeal from "./views/VFAppDetailsViewDeal.vue";
import VFVerifyUserListSearch from "./views/VFVerifyUserListSearch.vue";
import VFVerifyUserRegist from "./views/VFVerifyUserRegist.vue";
import VFVerifyUserModify from "./views/VFVerifyUserModify.vue";
import VFPwdChange from "./views/VFPwdChange.vue";



Vue.use(Router);

/* 
 *  ルータ設定
 */
export default new Router({
  // hashモード or historyモード
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: -1 };
    }
  },
  // ルーティング
  routes: [
    
    { path: '/comregtaqusu', name: "PSS100", component: HomePage },
    { path: '/comregtaqusu/web/homepagemainte', name: "PSS110", component: HomePageMainte },
    { path: "/comregtaqusu/web/servicepolicy/:kbnTyp/:KbnCd/:srcScreenId", name: "PSS200", component: ServicePolicy, props: true },
    { path: "/comregtaqusu/web/help/:kbnTyp/:KbnCd/:srcScreenId", name: "PSS300", component: Help, props: true },
    { path: '/comregtaqusu/web/inquiry/:srcScreenId', name: "PSS400", component: Inquiry, props: true },
    { path: '/comregtaqusu/web/login', name: "MBA100", component: Login },
    { path: '/comregtaqusu/web/resetpwdrequest', name: "MBA200", component: ResetPwdRequest },
    { path: '/comregtaqusu/web/authconfirm/:authCd/:reqDatetime/:validMinutes', name: "MBA300", component: AuthConfirm, prpos: true},
    { path: '/comregtaqusu/web/accountregist', name: "MBC100", component: AccountRegist },
    { path: '/comregtaqusu/web/accountmodify/:srcScreenId', name: "MBC110", component: AccountModify, props: true },
    { path: '/comregtaqusu/web/accountsuspend/:srcScreenId', name: "MBC120", component: AccountSuspend, props: true },
    { path: '/comregtaqusu/web/pwdchange/:srcScreenId', name: "MBC200", component: PwdChange },
    { path: '/comregtaqusu/web/pwdreset/:onetimeurl', name: "MBC210", component: PwdReset},
    { path: '/comregtaqusu/web/memberhome', name: "MBR100", component: MemberHome },
    // { path: '', name: "MBR200", component: null },
    // { path: '', name: "MBR300", component: null },
    // { path: '', name: "MBR310", component: null },
    { path: '/comregtaqusu/web/inputrequesthome', name: "MBR400", component: InputRequestHome },
    { path: '/comregtaqusu/web/inputrequestconfirm/:requestNo/:srcScreenId', name: "MBR500", component: InputRequestConfirm },
    { path: '/comregtaqusu/web/inputrequestconfirmregist', name: "MBR510", component: InputRequestConfirmRegist, props: true },
    { path: '/comregtaqusu/web/inputrequestafterdescription', name: "MBR600", component: InputRequestAfterDescription },


    { path: '/comregtaqusu/web/mainte/login', name: "MTA100", component: MainteLogin },
    // { path: '', name: "MTM100", component: null },
    { path: '/comregtaqusu/web/mainte/managerhome', name: "MTO100", component: MainteManagerHome },
    { path: '/comregtaqusu/web/mainte/accountregist', name: "MTO200", component: MainteAccountRegist },
    { path: '/comregtaqusu/web/mainte/accountmodify/:userNo', name: "MTO210", component: MainteAccountModify, props: true },
    { path: '/comregtaqusu/web/mainte/accountlistsearch/', name: "MTO220", component: MainteAccountListSearch, props: true },
    { path: '/comregtaqusu/web/mainte/inquirylistsearch/:srcScreenId', name: "MTQ100", component: MainteInquiryListSearch, props: true },
    { path: '/comregtaqusu/web/mainte/inquiryconfirm/:inquiryNo/:srcScreenId', name: "MTQ200", component: MainteInquiryConfirm, props: true },
    { path: '/comregtaqusu/web/mainte/requestlistsearch/:srcScreenId', name: "MTR100", component: MainteRequestListSearch, props: true },
    { path: '/comregtaqusu/web/mainte/requestconfirm/:requestNo/:srcScreenId', name: "MTR200", component: MainteRequestConfirm, props: true },
    

    { path: '/comregtaqusu/web/verify/homepage', name: "PSC100", component: VFHomePage},
    { path: '/comregtaqusu/web/verify/homepagemainte', name: "PSC210", component: VFHomePageMainte},
    { path: '/comregtaqusu/web/verify/verifyguidance/:accesskey/:receiptno/:systemid', name: "APA100", component: VFVerifyGuidance, props: true},
    { path: '/comregtaqusu/web/verify/verifydocselect', name: "APA200", component: VFVerifyDocSelect},
    { path: '/comregtaqusu/web/verify/docphoto1', name: "APA300", component: VFDocPhoto1},
    { path: '/comregtaqusu/web/verify/docphoto2', name: "APA310", component: VFDocPhoto2},
    { path: '/comregtaqusu/web/verify/docphoto3', name: "APA320", component: VFDocPhoto3},
    { path: '/comregtaqusu/web/verify/facephoto1', name: "APA400", component: VFFacePhoto1},
    { path: '/comregtaqusu/web/verify/facephoto2', name: "APA410", component: VFFacePhoto2},
    { path: '/comregtaqusu/web/verify/appcompleted', name: "APA500", component: VFAppCompleted},

    { path: '/comregtaqusu/web/verify/login', name: "VFA100", component: VFLogin},
    { path: '/comregtaqusu/web/verify/verifyhome', name: "VFV100", component: VFVerifyHome, props: true},
    { path: '/comregtaqusu/web/verify/receiptapplistsearch', name: "VFV200", component: VFReceiptAppListSearch, props: true},
    { path: '/comregtaqusu/web/verify/appdetailsviewdeal/:receiptNo/:srcScreenId', name: "VFV210", component: VFAppDetailsViewDeal, props: true},
    { path: '/comregtaqusu/web/verify/verifyuserlistsearch', name: "VFU100", component: VFVerifyUserListSearch, props: true},
    { path: '/comregtaqusu/web/verify/verifyuserregist', name: "VFU200", component: VFVerifyUserRegist, props: true},
    { path: '/comregtaqusu/web/verify/verifyusermodify/:verifyUserId/:srcScreenId', name: "VFU210", component: VFVerifyUserModify, props: true},
    { path: '/comregtaqusu/web/verify/pwdchange/:verifyUserId/:srcScreenId', name: "VFU220", component: VFPwdChange},

    { path: '/*', name: "401", component: HomePage },
  ]
});
